import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { URL_IMAGES_BANKS } from 'constants/UrlConstants';

import AnimatedBanks from './AnimatedBanks';

const Banks = (props) => {
    const data = props.data;
    const render = (data) => {
        const { header, title, banks, banksInfo } = data;
        const condBanksAnimated = Array.isArray(banksInfo) && banksInfo.length > 5;
        const renderStaticBanks = (banksAlt, banksArray) => {
            const renderBanks = banksArray.map((bank, index) => {
                const { logo, name } = bank;
                return (
                    <li key={`${name}${index}`}>
                        <figure>
                            <img height="64" width="64" alt={banksAlt[index]} src={`${URL_IMAGES_BANKS}/${logo}`} />
                            <figcaption className="smallcopy color-medium-gray">{name}</figcaption>
                        </figure>
                    </li>
                );
            });
            return (
                <ul className="bank-logos static">
                    {renderBanks}
                    <li className="">
                        <figure>
                            <img height="64" width="64" alt="bank" src={`${URL_IMAGES_BANKS}/more.png`} />
                            <figcaption className="smallcopy color-medium-gray">{props.manyMore}</figcaption>
                        </figure>
                    </li>
                </ul>
            );
        };

        return (
            <div className="section-banks no-spinner" id="section-banks">
                <div className="box-1280">
                    <div className="inner-content">
                        <div className="lead-text max-620">
                            <h2 className="title1">{header}</h2>
                            <div className="maincopy color-medium-gray">{title}</div>
                        </div>
                        <div className="icons-container">{condBanksAnimated ? <AnimatedBanks data={data} /> : renderStaticBanks(banks, banksInfo)}</div>
                    </div>
                </div>
            </div>
        );
    };
    return !props.isShowSpinner && (data && data.banksInfo.length > 0 ? render(data) : null);
};
const mapStateToProps = (state) => {
    return {
        manyMore: state.messages.pageMessages.manyMore,
        isShowSpinner: state.app.isShowSpinner,
    };
};
Banks.propTypes = {
    data: PropTypes.shape({
        banks: PropTypes.arrayOf(PropTypes.string),
        header: PropTypes.string,
        title: PropTypes.string,
        banksInfo: PropTypes.array,
    }),
    manyMore: PropTypes.string,
    isShowSpinner: PropTypes.bool,
};

export default connect(mapStateToProps)(Banks);
